import { visibleCompanionActionCount } from '@/components/companion/feed/companion-feed-state';
import type { CompanionFeedDto } from '@fluenceur/types';

/**
 * What the panel's trigger says. The panel answers questions without the feed,
 * so a feed that is missing, loading or switched off leaves the trigger idle
 * rather than hiding it. « À vérifier » waits for stale drafts (a later wave).
 */
export type PanelTriggerState = 'analysing' | 'actions' | 'idle';

export interface PanelTrigger {
  state: PanelTriggerState;
  /** Visible cards, the same total the greeting announces. */
  count: number;
}

const COUNT_CAP = 9;

export const resolvePanelTriggerState = (feed: CompanionFeedDto | undefined): PanelTrigger => {
  if (!feed?.availability.enabled) return { state: 'idle', count: 0 };
  const count = visibleCompanionActionCount(feed);
  if (count > 0) return { state: 'actions', count };
  return { state: feed.lastSuccessfulRun ? 'idle' : 'analysing', count };
};

export const formatTriggerCount = (count: number): string =>
  count > COUNT_CAP ? `${COUNT_CAP}+` : String(count);
